/** The texts of the forum (FOR-*), spread into the app's dictionaries (`lib/i18n.tsx`). */
export const forumEn = {
  forum: 'Forum',
  forumIntro: 'Questions and answers about the platform, the guidelines, research methods and teaching. Text only: link to a study instead of describing a patient.',
  forumAll: 'All',
  forumUnread: 'Unread',
  forumFollowing: 'Following',
  forumAllCategories: 'All categories',
  forumFindTopics: 'Find topics',
  forumViews: 'Show',
  forumTopics: 'Topics',
  forumAllTopics: 'All topics',
  forumCategory: 'Category',
  forumSearch: 'Search the forum',
  forumNewTopic: 'New topic',
  forumTitle: 'Title',
  forumText: 'Text',
  forumPost: 'Post',
  forumReply: 'Reply',
  forumNoTopics: 'No topics here yet.',
  forumMore: 'More topics',
  forumReplies: '{count} replies',
  forumReplies_one: '1 reply',
  forumUnreadMark: 'unread',
  forumPinned: 'Pinned',
  forumLocked: 'Locked',
  forumLockedHint: 'This topic is locked: it takes no new replies.',
  forumEdited: 'edited {when}',
  forumFormerUser: 'Former user',
  forumLearner: 'Learner',
  forumModerator: 'Moderator',
  forumDeleted: 'This post was deleted.',
  forumRemoved: 'A moderator removed this post.',
  forumHeld: 'This post is hidden while a moderator checks it.',
  forumHeldOwn: 'Hidden from others while a moderator checks it.',
  forumNoTitle: 'Title removed',
  forumFirstUnread: 'First unread post',
  forumFollow: 'Follow',
  forumUnfollow: 'Stop following',
  forumFollowHint: 'Followers are notified of new replies.',
  forumActions: 'Actions',
  forumEdit: 'Edit',
  forumDelete: 'Delete',
  forumDeleteConfirm: 'Delete this post for good? Its text cannot be restored.',
  forumRename: 'Rename',
  forumFlag: 'Flag to the moderators',
  forumFlagged: 'Flagged. Thank you.',
  forumFlagReason: 'Why?',
  flag_patient_data: 'It identifies a patient',
  flag_rules: 'It breaks the forum rules',
  flag_category: 'It is in the wrong category',
  forumMove: 'Move to',
  forumPin: 'Pin',
  forumUnpin: 'Unpin',
  forumLock: 'Lock',
  forumUnlock: 'Unlock',
  forumPage: 'Page {page} of {pages}',
  forumRules:
    'Forum rules: no patient data such as names, numbers or dates; no findings of studies a blinded job is still reading, no benchmark references and no assessment answers; stay on the platform’s purpose.',
  forumDraftKept: 'Your text is kept in this tab until it is posted.',
  forumModeration: 'Moderation',
  forumFlaggedPosts: 'Flagged posts',
  forumNoFlags: 'No flagged posts.',
  forumDismiss: 'Keep the post',
  forumRemove: 'Remove the post',
  forumCategories: 'Categories',
  forumCategoriesHint: 'Users who are only learners see the categories open to learners.',
  forumOpenToLearners: 'Open to learners',
  forumNameEn: 'Name (English)',
  forumNameDe: 'Name (German)',
  forumAddCategory: 'Add a category',
  forumModerators: 'Moderators',
  forumModeratorsHint: 'Moderators decide on flagged posts and rename, move, pin and lock topics. Platform admins moderate too.',
  forumAddModerator: 'Add a moderator',
  notice_forum_reply: '{count} new replies in a forum topic you follow',
  notice_forum_reply_one: 'A new reply in a forum topic you follow',
  notice_forum_flag: 'A forum post was flagged to the moderators',
  notice_forum_removed: 'A moderator removed your forum post. Reason: {reason}',
  kind_forum_reply: 'Replies in forum topics I follow',
  kind_forum_flag: 'A forum post is flagged (moderators)',
  role_forum_moderator: 'Forum moderator',
  allow_forum_moderate: 'decide on flagged posts and rename, move, pin and lock topics in the forum',
}

export const forumDe: Record<keyof typeof forumEn, string> = {
  forum: 'Forum',
  forumIntro: 'Fragen und Antworten zur Plattform, zu den Richtlinien, zu Forschungsmethoden und zur Lehre. Nur Text: Verlinken Sie eine Studie, statt eine Person zu beschreiben.',
  forumAll: 'Alle',
  forumUnread: 'Ungelesen',
  forumFollowing: 'Gefolgt',
  forumAllCategories: 'Alle Kategorien',
  forumFindTopics: 'Themen finden',
  forumViews: 'Anzeigen',
  forumTopics: 'Themen',
  forumAllTopics: 'Alle Themen',
  forumCategory: 'Kategorie',
  forumSearch: 'Im Forum suchen',
  forumNewTopic: 'Neues Thema',
  forumTitle: 'Titel',
  forumText: 'Text',
  forumPost: 'Veröffentlichen',
  forumReply: 'Antworten',
  forumNoTopics: 'Hier gibt es noch keine Themen.',
  forumMore: 'Weitere Themen',
  forumReplies: '{count} Antworten',
  forumReplies_one: '1 Antwort',
  forumUnreadMark: 'ungelesen',
  forumPinned: 'Angeheftet',
  forumLocked: 'Gesperrt',
  forumLockedHint: 'Dieses Thema ist gesperrt: Es nimmt keine neuen Antworten an.',
  forumEdited: 'bearbeitet {when}',
  forumFormerUser: 'Ehemaliges Mitglied',
  forumLearner: 'Lernende Person',
  forumModerator: 'Moderation',
  forumDeleted: 'Dieser Beitrag wurde gelöscht.',
  forumRemoved: 'Die Moderation hat diesen Beitrag entfernt.',
  forumHeld: 'Dieser Beitrag ist ausgeblendet, während die Moderation ihn prüft.',
  forumHeldOwn: 'Für andere ausgeblendet, während die Moderation ihn prüft.',
  forumNoTitle: 'Titel entfernt',
  forumFirstUnread: 'Erster ungelesener Beitrag',
  forumFollow: 'Folgen',
  forumUnfollow: 'Nicht mehr folgen',
  forumFollowHint: 'Wer folgt, wird über neue Antworten benachrichtigt.',
  forumActions: 'Aktionen',
  forumEdit: 'Bearbeiten',
  forumDelete: 'Löschen',
  forumDeleteConfirm: 'Diesen Beitrag endgültig löschen? Sein Text lässt sich nicht wiederherstellen.',
  forumRename: 'Umbenennen',
  forumFlag: 'Der Moderation melden',
  forumFlagged: 'Gemeldet. Danke.',
  forumFlagReason: 'Warum?',
  flag_patient_data: 'Er lässt eine Person erkennen',
  flag_rules: 'Er verstößt gegen die Forumsregeln',
  flag_category: 'Er steht in der falschen Kategorie',
  forumMove: 'Verschieben nach',
  forumPin: 'Anheften',
  forumUnpin: 'Lösen',
  forumLock: 'Sperren',
  forumUnlock: 'Entsperren',
  forumPage: 'Seite {page} von {pages}',
  forumRules:
    'Forumsregeln: keine Patientendaten wie Namen, Nummern oder Daten; keine Befunde von Studien, die ein verblindeter Auftrag noch liest, keine Benchmark-Referenzen und keine Antworten auf Prüfungen; beim Zweck der Plattform bleiben.',
  forumDraftKept: 'Ihr Text bleibt in diesem Tab erhalten, bis er veröffentlicht ist.',
  forumModeration: 'Moderation',
  forumFlaggedPosts: 'Gemeldete Beiträge',
  forumNoFlags: 'Keine gemeldeten Beiträge.',
  forumDismiss: 'Beitrag behalten',
  forumRemove: 'Beitrag entfernen',
  forumCategories: 'Kategorien',
  forumCategoriesHint: 'Wer nur lernende Person ist, sieht die Kategorien, die für Lernende offen sind.',
  forumOpenToLearners: 'Für Lernende offen',
  forumNameEn: 'Name (Englisch)',
  forumNameDe: 'Name (Deutsch)',
  forumAddCategory: 'Kategorie hinzufügen',
  forumModerators: 'Moderation',
  forumModeratorsHint: 'Die Moderation entscheidet über gemeldete Beiträge und benennt Themen um, verschiebt, heftet an und sperrt sie. Plattform-Admins moderieren ebenfalls.',
  forumAddModerator: 'Moderation hinzufügen',
  notice_forum_reply: '{count} neue Antworten in einem Forumsthema, dem Sie folgen',
  notice_forum_reply_one: 'Eine neue Antwort in einem Forumsthema, dem Sie folgen',
  notice_forum_flag: 'Ein Forumsbeitrag wurde der Moderation gemeldet',
  notice_forum_removed: 'Die Moderation hat Ihren Forumsbeitrag entfernt. Grund: {reason}',
  kind_forum_reply: 'Antworten in Forumsthemen, denen ich folge',
  kind_forum_flag: 'Ein Forumsbeitrag wird gemeldet (Moderation)',
  role_forum_moderator: 'Forum-Moderation',
  allow_forum_moderate: 'über gemeldete Beiträge entscheiden und Themen im Forum umbenennen, verschieben, anheften und sperren',
}
